<template>
  <v-layout class="mt-2" justify-center>
    <v-flex class="grey--text font-italic caption text-xs-center" shrink>
      Validado el {{ date }} a las {{ time }}
      <span
        v-if="item.validatorEmail"
      >por {{ item.validatorEmail }}</span>
      <template v-if="showClassificationMessage">
        y quedó en la clasificación
        <router-link
          @click.stop
          :to="{ name: 'classifier/predictions/validated', params: { classificationId: item.classificationId }}"
        >{{ item.classificationId }}</router-link>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("classifier");

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(["currentClassification"]),
    date() {
      return this.item.validationDate
        ? this.item.validationDate.split("T")[0]
        : "";
    },
    showClassificationMessage() {
      return (
        this.item.classificationId &&
        this.item.classificationId !== this.currentClassification.id
      );
    },
    time() {
      return new Date(this.item.validationDate).toLocaleTimeString();
    }
  }
};
</script>